<template>
  <span id="start">
    <details-component></details-component>
    <v-btn class="margin" absolute fixed fab bottom right @click="$vuetify.goTo('#start')">
      <v-icon>mdi-arrow-up</v-icon>
    </v-btn>
  </span>
</template>

<script>
import DetailsComponent from "@/components/Team/DetailsComponent";

export default {
  name: "Details",
  components: {
    DetailsComponent
  }
};
</script>

<style scoped>
.margin {
  margin-bottom: 4rem !important;
}
</style>